"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var request_1 = require("../utils/request");
function longHttp(req) {
    return __awaiter(this, void 0, void 0, function () {
        var data, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, req];
                case 1:
                    data = (_a.sent()).data;
                    return [2 /*return*/, { continuable: true, data: data }];
                case 2:
                    e_1 = _a.sent();
                    /**
                     * requests are canceled in the following cases:
                     *
                     * - before we start a new poll, we clean the current one by cancelling it.
                     * - when we close the connection (so we can then reconnect).
                     */
                    if (request_1.isCancel(e_1)) {
                        return [2 /*return*/, { continuable: false }];
                    }
                    if (isGatewayTimeout(e_1)) {
                        // This way we support gateways/proxies with a lower timeout than our sockets server.
                        // If we don't do this, we'll create a different session on every poll.
                        // In the future we can detect such cases and fallback to polling transport.
                        return [2 /*return*/, { continuable: true }];
                    }
                    // in any other case, we throw a response error that should trigger close & reconnect.
                    throw e_1;
                case 3: return [2 /*return*/];
            }
        });
    });
}
exports.longHttp = longHttp;
function maybeHeaders(instanceUpdater) {
    var _a, _b;
    return (_b = (_a = instanceUpdater === null || instanceUpdater === void 0 ? void 0 : instanceUpdater.getHeaders) === null || _a === void 0 ? void 0 : _a.call(instanceUpdater)) !== null && _b !== void 0 ? _b : {};
}
exports.maybeHeaders = maybeHeaders;
function isGatewayTimeout(e) {
    return e.getStatus() === 504;
}
//# sourceMappingURL=http.js.map